export const el = {
  // Certificate Headers
  congrats_message: "Η εγκατάσταση του WiFi σας έχει ολοκληρωθεί και έχει πιστοποιηθεί από την RouteThis!",
  installation_details: "Λεπτομέρειες εγκατάστασης",
  wireless_speed_test: "Δοκιμή ασύρματης ταχύτητας",
  wireless_performance: "Wireless Performance",
  photos: "Φωτογραφίες",
  signal_maps: "Χάρτες Σήματος",

  // Certificate Room Names
  singular_room: "Δωμάτιο",
  room_type_bathroom: "Μπάνιο",
  room_type_bedroom: "Υπνοδωμάτιο",
  room_type_dining_room: "Τραπεζαρία",
  room_type_entry_or_hall: "Είσοδος/Διάδρομος",
  room_type_garage: "Γκαράζ",
  room_type_kitchen: "Κουζίνα",
  room_type_living_room: "Σαλόνι",
  room_type_office: "Γραφείο",
  room_type_other: "Άλλο",

  // Pod Name
  pod_1: "Μονάδα Πλέγματος",
  pod_2: "Σημείο Πρόσβασης",
  pod_3: "Κόμβος Πλέγματος",
  pod_4: "Δίσκος Πλέγματος",
  pod_5: "Πομπός μετάδοσης",
  pod_6: "Μονάδα Πλέγματος",
  pods_1: "Μονάδες Πλέγματος",
  pods_2: "Σημεία πρόσβασης",
  pods_3: "Κόμβοι πλέγματος",
  pods_4: "Δίσκοι Πλέγματος",
  pods_5: "Πομποί μετάδοσης",
  pods_6: "Μονάδες Πλέγματος",

  // Router Name
  router_1: "Δρομολογητής",
  router_2: "Μόντεμ",
  router_3: "Πύλη",
  router_4: "Κόμβος",

  // Level Name
  level_1: "Επίπεδο",
  level_2: "Όροφος",
  levels_1: "Επίπεδα",
  levels_2: "Όροφοι",

  // Certificate Pod Info
  recommended: "Συνιστώμενο",
  installed: "Εγκατεστημένο",
  total: "Σύνολο",

  // Certificate Signal Table
  front_building: "Πρόσοψη Κτιρίου",
  speed: "Ταχύτητα",
  video: "Βίντεο",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Σύνδεσμος",
  frequency_short: "Συχν.",
  frequency_description: "MHz",
  channel_short: "Καν.",

  // Certificate Legend
  legend: "Υπόμνημα",
  measured_speed: "Μετρηθείσα ταχύτητα",
  measured_speed_description: "Mbps",

  // Certificate Speedtest Result
  speedtest_passed: "Η ταχύτητα είναι εντός του αναμενόμενου εύρους για τις περισσότερες κινητές συσκευές. Δεν είναι όλες οι ασύρματες συσκευές ικανές να επιτύχουν τη μέγιστη ταχύτητα του προγράμματος. Ανατρέξτε παρακάτω για μεμονωμένες δοκιμές δωματίου.",
  speedtest_failed: "Δοκιμάστηκε σε τηλέφωνο ή τάμπλετ. Δεν είναι όλες οι ασύρματες συσκευές ικανές να επιτύχουν τη μέγιστη ταχύτητα του προγράμματος. Ανατρέξτε παρακάτω για μεμονωμένες δοκιμές δωματίου.",
}